import styles from './Text.module.scss'
import cx from 'classnames'
import React from 'react'

type TextProps = {
    children: string | JSX.Element
    classes?: string
}

const Text: React.FC<TextProps> = ({ children, classes }) => {
    return <p className={cx(styles['zr-text'], classes)}>{children}</p>
}

export default Text
